import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

const SPLIT_UPLOAD_CHUNK_SIZE = 20 * 1000 * 1000;
const LEGACY_SPLIT_UPLOAD_PATH = "/uploadSplit";
const DIRECT_SPLIT_UPLOAD_PATH = "/uploadSplitDirect";

const isWebUploadMode = mode => mode === "web" || mode === "new-web";

const isWhisperUpload = isWhisper => isWhisper === true || isWhisper === "Y";

const appendWebUploadFields = (form, {
    teacherSeq,
    liveSeq,
    userSeq,
    userNickname,
    smallGroupKey,
    isWhisper,
    isMixedClassMember,
    mixedClassStatus,
    localServerSeq,
    localLiveSeq,
    localTeacherSeq,
    isOverwriteAllowed,
    executeYn,
    isAutoDownloadAllowed,
    fileTransferType
}) => {
    form.append("teacherSeq", teacherSeq);
    form.append("liveSeq", liveSeq);
    form.append("userSeq", userSeq);
    form.append("userNickname", userNickname);
    form.append("whisperYN", isWhisperUpload(isWhisper) ? "Y" : "N");
    form.append("isMixedClassMember", isMixedClassMember);
    form.append("mixedClassStatus", mixedClassStatus);

    if (isMixedClassMember === "Y") {
        form.append("localServerSeq", localServerSeq);
        form.append("localLiveSeq", localLiveSeq);
        form.append("localTeacherSeq", localTeacherSeq);
    }

    if (smallGroupKey && smallGroupKey !== "") {
        form.append("smallGroupKey", smallGroupKey);
    }

    if (isOverwriteAllowed !== undefined) {
        form.append("isOverwriteAllowed", isOverwriteAllowed ? "Y" : "N");
    }

    if (executeYn !== undefined) {
        form.append("executeYn", executeYn);
    }

    if (isAutoDownloadAllowed !== undefined) {
        form.append("isAutoDownloadAllowed", isAutoDownloadAllowed);
    }

    if (fileTransferType !== undefined) {
        form.append("fileTransferType", fileTransferType);
    }
};

const upload_file_for_split = async (params, splitUploadPath = LEGACY_SPLIT_UPLOAD_PATH, directUploadYN = false) => {
    const { data, filename, storageFileName, mode, command, onUploadProgress } = params;
    // 20260714 추가: storageFileName(랜덤문자+GroupSeq 등으로 새로 생성된 저장용 파일명)이 있으면
    // 실제 서버에는 그 이름으로 저장되도록 하고, 없으면 기존처럼 원본 filename을 그대로 사용함 ... by hjkim
    const uploadFileName = storageFileName || filename;
    const totalSize = data && data.size !== undefined ? data.size : 0;
    const totalCount = Math.max(Math.ceil(totalSize / SPLIT_UPLOAD_CHUNK_SIZE), 1);
    let splitID = null;
    let response = null;

    if (onUploadProgress) {
        onUploadProgress(0);
    }

    try {
        for (let splitSeq = 0; splitSeq < totalCount; splitSeq++) {
            const start = splitSeq * SPLIT_UPLOAD_CHUNK_SIZE;
            const end = Math.min(start + SPLIT_UPLOAD_CHUNK_SIZE, totalSize);
            const splitEndYN = splitSeq === totalCount - 1 ? "Y" : "N";
            const form = new FormData();

            form.append("file", data.slice(start, end), uploadFileName);
            form.append("mode", mode);
            form.append("command", command);
            form.append("splitSeq", splitSeq);
            form.append("splitEndYN", splitEndYN);

            if (directUploadYN) {
                form.append("directUploadYN", "Y");
                // 20260901 추가: 직접 기록 서비스가 파일의 위치를 계산할 수 있도록 전체 크기와 청크 크기를 전달한다.
                form.append("totalFileSize", totalSize);
                form.append("splitChunkSize", SPLIT_UPLOAD_CHUNK_SIZE);
            }

            if (splitID) {
                form.append("splitID", splitID);
            }

            appendWebUploadFields(form, params);

            response = await axiosClient.post(splitUploadPath, form, options);

            if (onUploadProgress) {
                onUploadProgress(Math.floor(((splitSeq + 1) / totalCount) * 100));
            }

            if (!response.data || response.data.isSuccessed !== true) {
                if (onUploadProgress) {
                    onUploadProgress(100);
                }
                return response;
            }

            if (splitSeq === 0 && response.data.splitID) {
                splitID = response.data.splitID;
            }
        }
    } catch (err) {
        if (onUploadProgress) {
            onUploadProgress(100);
        }
        throw err;
    }

    return response;
};

const upload_file_for_split_direct = params => {
    // 20260908 수정: 일반 전송과 귓속말을 포함한 new-web 파일은 기존 요청 필드를 유지한 채 직접 저장 경로를 사용한다.
    return upload_file_for_split(params, DIRECT_SPLIT_UPLOAD_PATH, true);
};

export const upload_file = ({
    data,
    filename,
    storageFileName,
    mode,
    command,
    chatRoomSeq,
    memberSeqList,
    teacherSeq,
    liveSeq,
    userSeq,
    userNickname,
    smallGroupKey,
    isWhisper,
    isMixedClassMember,
    mixedClassStatus,
    localServerSeq,
    localLiveSeq,
    localTeacherSeq,
    isOverwriteAllowed,
    executeYn,
    isAutoDownloadAllowed,
    fileTransferType,
    onUploadProgress
}) => {
    console.log("api upload file:) mode[", mode, "], command[", command, "], filename[", filename, "], storageFileName[", storageFileName, "]");
    console.log("api upload file:) teacherSeq[", teacherSeq, "], userSeq[", userSeq, "], userNickname[", userNickname, "]");
    console.log("api upload file:) smallGroupKey[", smallGroupKey, "]");

    if (!data || !mode || mode === "") {
        console.log("api upload file:) request failed ... mode or data is undefined ... mode[", mode, "], data => ", data);
        return;
    }

    // 20260714 추가: storageFileName(랜덤문자+GroupSeq 등으로 새로 생성된 저장용 파일명)이 있으면
    // 실제 서버에는 그 이름으로 저장되도록 하고, 없으면 기존처럼 원본 filename을 그대로 사용함.
    // filename은 화면 표시(말풍선 등)용으로 그대로 유지됨 ... by hjkim
    const uploadFileName = storageFileName || filename;

    // 20260723 추가: "new-"로 시작하지 않는 mode는 "new-"로 시작하도록 변경함 ... by hjkim
    if (!mode.startsWith("new-")) {
        mode = "new-" + mode;
    }

    console.log("api upload file:) uploadFileName[", uploadFileName, "], mode[", mode, "]");

    const params = {
        data,
        filename,
        storageFileName,
        mode,
        command,
        teacherSeq,
        liveSeq,
        userSeq,
        userNickname,
        smallGroupKey,
        isWhisper,
        isMixedClassMember,
        mixedClassStatus,
        localServerSeq,
        localLiveSeq,
        localTeacherSeq,
        isOverwriteAllowed,
        executeYn,
        isAutoDownloadAllowed,
        fileTransferType,
        onUploadProgress
    };

    // 20260908 수정: 웹 귓속말도 일반 웹 전송과 같은 직접 청크 저장 경로를 사용한다.
    if (isWebUploadMode(mode)) {
        return upload_file_for_split_direct(params);
    }

    const form = new FormData();
    form.append("file", data, uploadFileName);
    form.append("mode", mode);
    form.append("command", command);

    if (isWebUploadMode(mode)) {
        console.log("api upload file mode web:) liveSeq[", liveSeq, "], smallGroupKey[", smallGroupKey, "], isWhisper[", isWhisper, "]");
        console.log("api upload file mode web:) isMixedClassMember[", isMixedClassMember, "], mixedClassStatus[", mixedClassStatus, "]");
        console.log("api upload file mode web:) localServerSeq[", localServerSeq, "], localLiveSeq[", localLiveSeq, "], localTeacherSeq[", localTeacherSeq, "]");
        appendWebUploadFields(form, params);
    } else if (mode === "hiclass" || mode === "new-hiclass") {
        console.log("api upload file mode hiclass:) chatRoomSeq[", chatRoomSeq, "], mixedClassStatus[", mixedClassStatus, "], memberSeqList => ", memberSeqList);

        form.append("teacherSeq", teacherSeq);
        form.append("chatRoomSeq", chatRoomSeq);
        form.append("userSeq", 0);
        form.append("userNickname", userNickname);
        form.append("mixedClassStatus", mixedClassStatus);

        if (memberSeqList && memberSeqList.length > 0) {
            form.append("memberSeqList", memberSeqList.map(info => info.userSeq));
        } else {
            console.log("api upload file mode hiclass:) memberSeqList is undefined or memberSeqList length is 0 => ", memberSeqList);
        }
    }

    return axiosClient.post(`/upload`, form, options);
}

export const download_file = ({ url }) => {
    console.log("api get download file:) url[", url, "]");

    return axiosClient.get(`/download/${url}`, options);
}

export const get_download_file_list = ({ teacherSeq, liveSeq }) => {
    console.log("api get download file list:) teacherSeq[", teacherSeq, "], liveSeq[", liveSeq, "]");

    return axiosClient.get(`/download-list/${teacherSeq}/${liveSeq}`, options);
}

export const clear_download_files = ({ teacherSeq, liveSeq }) => {
    console.log("api clear download files:) teacherSeq[", teacherSeq, "], liveSeq[", liveSeq, "]");

    return axiosClient.delete(`/download-clear/${teacherSeq}/${liveSeq}`, options);
}
